import { stringify } from 'query-string';

import { sortOrderTypes } from 'types/shared';
import getCountryIds from 'helpers/getCountryIds';

export interface IArtistConcertsUrlArgs {
  countryIds?: string | string[];
  customerFilter?: number;
  dateFrom?: Date | number;
  dateTo?: Date | number;
  dateStatus?: 'upcoming' | 'past';
  download?: boolean;
  entityId: string[];
  limit?: number;
  managerStatus?: string;
  offset?: number;
  region?: string;
  sortOrder?: sortOrderTypes;
  sortBy?: string;
  customRegion?: string | string[];
}

const getArtistConcertsUrl = (args: IArtistConcertsUrlArgs): string => {
  const {
    countryIds,
    customerFilter,
    dateFrom,
    dateTo,
    dateStatus,
    download,
    entityId,
    limit,
    managerStatus,
    offset,
    region,
    sortOrder = 'desc',
    sortBy = 'date',
    customRegion,
  } = args;

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    dateFrom,
    dateTo,
    dateStatus,
    download,
    limit,
    managerStatus,
    offset,
    sortOrder,
    sortBy,
  });

  return `/api/concert/artist/${entityId}?${params}`;
};

export default getArtistConcertsUrl;
